import request from "@/utils/request";
const baseUrl = `${process.env.VUE_APP_COMMON_SERVICE}/api/v1/dropdown`;
const compliancebaseUrl = `${process.env.VUE_APP_COMMON_SERVICE}/api/v1/compliance`;
const LogsbaseUrl = `${process.env.VUE_APP_COMMON_SERVICE}/api/v1/logs`;
export default {
  getdropdowns() {
    return request({
      url: `${baseUrl}/all-countries`,
      method: "get",
    });
  },
  getStates(code) {
    return request({
      url: `${baseUrl}/get-all-states?country_code=${code}`,
      method: "get",
    });
  },
  getparameterdropdowns(code) {
    return request({
      url: `${baseUrl}/get-parameter-data?parameter_code=${code}`,
      method: "GET",
    });
  },
  getparameterdrop(params) {
    return request({
      url: `${baseUrl}/get-parameter-data-by-user-type`,
      method: "GET",
      params: params,
    });
  },
  getPartnerdropdown() {
    return request({
      url: `${baseUrl}/admin-get-partner`,
      method: "get",
    });
  },
  getAllPartnersdropdown() {
    return request({
      url: `${baseUrl}/get-all-partners`,
      method: "get",
    });
  },

  gettimeZone() {
    return request({
      url: `${baseUrl}/timezones`,
      method: "get",
    });
  },
  getPayPartner(countrycode) {
    return request({
      url: `${baseUrl}/admin-get-paying-country?country_code=${countrycode}`,
      method: "get",
    });
  },
  getmainSenderpartner(params) {
    return request({
      url: `${baseUrl}/main-sending-partner`,
      method: "get",
      params: params,
    });
  },
  getmainSenderpartnerbyusername(params) {
    return request({
      url: `${baseUrl}/main-sending-partner-current-user`,
      method: "get",
      params: params,
    });
  },
  //-----------------------------ADD CUSTOMERS-------------------------------//

  getCountryBirthList() {
    return request({
      url: `${baseUrl}/all-countries`,
      method: "get",
    });
  },
  getStatesList(country_code) {
    return request({
      url: `${baseUrl}/get-all-states?country_code=${country_code}`,
      method: "get",
    });
  },
  getCitiesList(country_code, state_code) {
    return request({
      url: `${baseUrl}/get-all-cities?country_code=${country_code}&state_code=${state_code}`,
      method: "get",
    });
  },
  getSourceFunds() {
    return request({
      url: `${baseUrl}/get-parameter-data?parameter_code=SOF`,
      method: "get",
    });
  },
  getZipCodes() {
    return request({
      url: `${baseUrl}/all-zipcodes`,
      method: "get",
    });
  },
  getOccupation() {
    return request({
      url: `${baseUrl}/get-parameter-data?parameter_code=OCC`,
      method: "get",
    });
  },
  //---------------------------------LIST OF CUSTOMERS-----------------------------//
  getRemarks() {
    return request({
      url: `${baseUrl}/get-parameter-data?parameter_code=TAR`,
      method: "get",
    });
  },
  //--------------------------------ADD BENIFICIERY INDIVIDUAL-----------------------------------------//
  getallPayoutCountries(params) {
    return request({
      url: `${baseUrl}/all-payout-countries`,
      method: "get",
      params: params,
    });
  },
  getBeneficiaryCountryList() {
    return request({
      url: `${baseUrl}/get-all-bene-country`,
      method: "get",
    });
  },
  getPaymentmode(country_code) {
    return request({
      url: `${baseUrl}/admin-get-payment-mode?country_code=${country_code}&user_type=IND`,
      method: "get",
    });
  },
  getPayoutLocByctry(params) {
    return request({
      url: `${baseUrl}/get-bank-list-ad`,
      method: "get",
      params: params,
    });
  },
  getPayLocate(payment_code, selectedCountry, Id) {
    return request({
      url: `${baseUrl}/agents-by-country?payment_mode=${payment_code}&country=${selectedCountry}&login_id=${Id}`,
      method: "get",
    });
  },
  getRelationships() {
    return request({
      url: `${baseUrl}/relationships`,
      method: "get",
    });
  },
  getDropdownByUsertype(type, code) {
    return request({
      url: `${baseUrl}/get-compliance-parameter-data?parameter_code=${code}&user_type=${type}`,
      method: "GET",
    });
  },
  getrateExchage(country_code, days) {
    return request({
      url: `${baseUrl}/get-graph-data?country=${country_code}&no_of_days=${days}`,
      method: "GET",
    });
  },
  // --------------------------------------COMPLAINCE BUS VALUE----------------------------------//
  getCompliancebusvalues(code) {
    return request({
      url: `${baseUrl}/admin-compliance-parameter-risk-factor?parameter_name=${code}`,
      method: "GET",
    });
  },
  getcompliancebusvalueScores(code) {
    return request({
      url: `${baseUrl}/admin-compliance-parameter-value-points?parameter_name=${code}`,
      method: "GET",
    });
  },
  //----------------------------Compliance Sanctions-------------------------------------------///
  getcompliancematchedsanctions(cust_id) {
    return request({
      url: `${compliancebaseUrl}/get-sanction-list?customer_id=${cust_id}`,
      method: "GET",
    });
  },
  getMatchedsRulesList(params) {
    return request({
      url: `${compliancebaseUrl}/get-rules-data`,
      method: "GET",
      params: params,
    });
  },
  getMatchedsList(data) {
    return request({
      url: `${compliancebaseUrl}/get-sanction-data?sanction_list=${data}`,
      method: "GET",
    });
  },
  getRiskProfilingData(risk_list, pin_no) {
    return request({
      url: `${compliancebaseUrl}/get-risk-data?txn_pin=${pin_no}`,
      method: "GET",
    });
  },
  getRecalculateScore(pin_no) {
    return request({
      url: `${compliancebaseUrl}/re-calculate-risk?txn_pin=${pin_no}&is_recalculate=${true}`,
      method: "GET",
    });
  },
  //-----------------API LOGS-----------//
  getApilog(params) {
    return request({
      url: `${LogsbaseUrl}/api-logs-data`,
      method: "GET",
      params: params,
    });
  },
  getserviceValues() {
    return request({
      url: `${baseUrl}/get-parameter-data?parameter_code=ALOG`,
      method: "get",
    });
  },
  getEndpointValues(serviceCode) {
    return request({
      url: `${baseUrl}/get-parameter-data?parameter_code=${serviceCode}`,
      method: "get",
    });
  },
  getErrorlogs(params) {
    return request({
      url: `${LogsbaseUrl}/all-error-logs-data`,
      method: "get",
      params: params,
    });
  },
  //-----------------INTEGRATION LOGS-----------//
  getIntegrationlog(params) {
    return request({
      url: `${LogsbaseUrl}/payment-partner-payment-logs-data`,
      method: "GET",
      params: params,
    });
  },
  getErrorserviceValues() {
    return request({
      url: `${baseUrl}/get-parameter-data?parameter_code=ELOG`,
      method: "get",
    });
  },
};
